import { formatISO } from 'date-fns';

const SCOPE = 'app/search/';

export const ActionTypes = {
    SUBMIT: `${SCOPE}SUBMIT`,
    CHANGE_DESTINATION: `${SCOPE}CHANGE_DESTINATION`,
    CHANGE_DESTINATION_ID: `${SCOPE}CHANGE_DESTINATION_ID`,
    CHANGE_DESTINATION_CATEGORY_ID: `${SCOPE}CHANGE_DESTINATION_CATEGORY_ID`,
    CHANGE_DATE: `${SCOPE}CHANGE_DATE`,
    CHANGE_DATE_FROM: `${SCOPE}CHANGE_DATE_FROM`,
    CHANGE_DATE_TO: `${SCOPE}CHANGE_DATE_TO`,
};

export const submit = () => ({
    type: ActionTypes.SUBMIT,
});

export const changeDestination = (destination = null, category = null) => ({
    type: ActionTypes.CHANGE_DESTINATION,
    destination,
    category,
});

export const changeDestinationId = (destinationId) => ({
    type: ActionTypes.CHANGE_DESTINATION_ID,
    destinationId,
});

export const changeDestinationCategoryId = (destinationCategoryId) => ({
    type: ActionTypes.CHANGE_DESTINATION_CATEGORY_ID,
    destinationCategoryId,
});

function formatDate(date) {
    if (!date) {
        return null;
    }

    if (typeof date === 'string') {
        return date;
    }

    if (date instanceof Date || typeof date === 'number') {
        return formatISO(date);
    }

    return null;
}

export const changeDate = (dateFrom, dateTo) => ({
    type: ActionTypes.CHANGE_DATE,
    dateFrom: formatDate(dateFrom),
    dateTo: formatDate(dateTo),
});

export const changeDateFrom = (dateFrom) => ({
    type: ActionTypes.CHANGE_DATE_FROM,
    dateFrom: formatDate(dateFrom),
});

export const changeDateTo = (dateTo) => ({
    type: ActionTypes.CHANGE_DATE_TO,
    dateTo: formatDate(dateTo),
});
